export default "__VITE_ASSET__BqVOr_sx__"